// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__ZLrq_","controls":"styles_controls__2qtlV","charLimit":"styles_charLimit__1j0CY","input":"styles_input__16M8w","send":"styles_send__3c0MH"};